import { useEffect, useState } from "react";
import { getCommunityVideoTimeLine } from '@/pages/opinion/services/video';
import { getRationPercentValue, pressTimeGrouping, supplementSingleData } from "@op/utils";

const useCommunityVideoTimeLineData = (props: any) => {
  const { type = 'counts', keepParams } = props || {};
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!keepParams?.edition_unified_id) return;
    setLoading(true);
    const params = {
      ...keepParams,
      metric: type,
    };
    getCommunityVideoTimeLine(params).then((data: any) => {
      if (data) {
        const {
          list,
          timeline_of_end_time,
          timeline_of_start_time,
          link_of_end_time,
          link_of_start_time,
          total_new,
          total_old,
        } = data || {};
        const format =
          params.date_type === 'hourly' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
        const newList = supplementSingleData(
          timeline_of_start_time,
          timeline_of_end_time,
          list?.map((item: { key: any; }) => ({ ...item, name: item.key })),
          params.date_type,
        );
        const timeGroup = pressTimeGrouping(newList, format);
        const result: Array<{
          positive: number;
          negative: number;
          time: string;
        }> = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const key in timeGroup) {
          const element = timeGroup[key];
          const obj: any = { x_axis: key, y_axis: {} };
          element.forEach(({ name, time, value }) => {
            obj.y_axis[name] = value;
            obj.x_axis = time;
          });
          result.push(obj);
        }
        setData({
          statistics: result,
          count: total_new,
          ratio: total_old,
          ratio_val: getRationPercentValue(total_new, total_old, 2),
          ratio_time_line: [link_of_start_time, link_of_end_time],
          time_line: [params.start_time, params.end_time],
        });
      } else {
        setData({});
      }
      setLoading(false);
    });
  }, [keepParams, type]);

  return {
    data,
    loading,
  };
};

export default useCommunityVideoTimeLineData;